/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import Loader from "../../general/Loader";
import PageHeader from "../../general/PageHeader";
import Pagination from "../../general/Pagination";
import { apiRequest } from "../../../hooks/apiRequest";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { Link, useParams } from "react-router-dom";
import { formatCurrency, getLink, toast } from "../../../utils/helpers";
import { apiUrl } from "../../../utils/apiUrl";
import Select from "react-select";
import PrefixedInput from "../../general/PrefixedInput";
import Modal from "../../general/Modal";
import {
	ChequeInfoCobrar,
	DepositoInfo,
	OtroInfo,
	TarjetaInfo,
	TransferenciaInfo,
} from "../../Ingresos/Components/PagoForm";
import FiltersContainer from "../../general/FiltersContainer";
import useFilters from "../../../hooks/useFilters";
import { METODOS_PAGO } from "../../../utils/types";
import { auth } from "../../../utils/auth";
import { request } from "../../../utils/request";

const History = () => {
	const { id } = useParams();
	const formRef = useRef();
	const formInfoPagoRef = useRef();
	const [contacto] = useLocalStorage("contacto", "");

	const [transacciones, setTransacciones] = useState({});
	const [vendedores, setVendedores] = useState([]);
	const [loading, setLoading] = useState(false);
	const [facturaSeleccionada, setFacturaSeleccionada] = useState({});
	const [pagoError, setPagoError] = useState({});
	const [printFacturaTipo] = useState("normal");
	const [pagoInfo, setPagoInfo] = useState({
		pago: 0,
		tipo_pago: "efectivo",
	});
	const { handleFilterChange, filtersQuery } = useFilters({
		buscar: "",
		tipo: "",
		estado: "",
		vendedor: "",
		desde: "",
		consultar: "",
		hasta: dayjs().format("YYYY-MM-DD"),
	});

	const getTransactions = async (url = null) => {
		setLoading(true);

        const response = await request(url);

        console.log({response})

        if (response.success) {
            setTransacciones(response.data);
        } else {
            toast("Error obteniendo transacciones", "error");
        }

		setLoading(false);
	};

	const renderEstadoBadge = (estado) => {
		if (estado === "pendiente") {
			return <span className="badge badge-secondary p-2">Pendiente</span>;
		} else if (estado === "pagada") {
			return <span className="badge badge-success p-2">Pagada</span>;
		} else if (estado === "facturada") {
			return <span className="badge badge-success p-2">Facturada</span>;
		} else if (estado === "cancelada") {
            return <span className="badge badge-danger p-2">Cancelada</span>;
		} else if (estado === "procesando") {
            return <span className="badge badge-warning p-2">Procesando</span>;
		}

		return <span className="badge badge-danger p-2">Desconocido</span>;
	};

	const getVendedoresForDropdown = useCallback(() => {
		apiRequest(null, "vendedores?limit=100", "get").then((res) => {
			const vendedores = res.data.filter((vendedor) => vendedor != null);
			setVendedores([
				{ value: "", label: "Todos" },
				...vendedores.map((vendedor) => ({
					value: vendedor.id,
					label: `${vendedor.nombre} ${vendedor.apellido}`,
				})),
			]);
		});
	}, []);

	const setPorPagar = () => {
		setPagoInfo((state) => ({
			...state,
			pago: facturaSeleccionada.por_cobrar,
		}));
	};

	useEffect(() => {
		getVendedoresForDropdown();
	}, []);

	useEffect(() => {
		if (filtersQuery === "") return;
		getTransactions(apiUrl(`contactos/${id}/transacciones${filtersQuery}`));
	}, [filtersQuery]);
	return (
		<>
			<PageHeader
				title={<Titulo contacto={`${contacto.codigo} - ${contacto.nombre}`} />}
				classes={{ title: "col-auto" }}
				hasButton={false}
			>
				<div
					className="col-2"
				>
					<label
						style={{ fontSize: "12px", textTransform: "uppercase" }}
					>
						Credito aprobado
					</label>
					<input
						type="text"
						className="form-control"
						id="credito_aprobado"
						value={formatCurrency(contacto.limite_credito)}
						readOnly
					/>
				</div>
				<div
					className="col-2"
				>
					<label
						style={{ fontSize: "12px", textTransform: "uppercase" }}
					>
						Credito disponible
					</label>
					<input
						type="text"
						className="form-control"
						id="credito_disponible"
						name="credito_disponible"
						value={formatCurrency(contacto.credito_disponible)}
						readOnly
					/>
				</div>

				<div className="col-2">
					<label
						style={{ fontSize: "12px", textTransform: "uppercase" }}
					>
						Consultar Productos
					</label>
					<input
						onChange={(e) =>
							handleFilterChange("consultar", e.target.value)
						}
						type="search"
						placeholder="Consultar..."
						className="form-control"
						name="consultar"
					/>
				</div>
				<Link
					to={getLink(
						`/imprimir/contactos/${id}/transacciones${filtersQuery}`
					)}
					target="_blank"
					className="au-btn-filter mr-2"
				>
					<i className="zmdi zmdi-print" /> Imprimir
				</Link>
				{contacto.tipo?.includes("Proveedor") && (
					<Link
						to={getLink(`/contactos/${id}/compras`)}
						target="_blank"
						className="au-btn-filter mr-2"
					>
						Historial Compras
					</Link>
				)}
				<Link
					className="au-btn au-btn-icon au-btn--green au-btn--small px-2"
					to={`${getLink("/ingresos/facturas/crear")}`}
				>
					<i className="zmdi zmdi-plus" />
					Añadir Factura
				</Link>
			</PageHeader>
			<FiltersContainer>
				<div className="col">
					<label>Buscar</label>
					<input
						onChange={(e) =>
							handleFilterChange("buscar", e.target.value)
						}
						type="search"
						placeholder="Buscar..."
						className="form-control"
						name="buscar"
					/>
				</div>
				<div className="col-md-2">
					<label>Tipo</label>
					<select
						className="form-control"
						name="tipo"
						id="tipo"
						onChange={(e) =>
							handleFilterChange("tipo", e.target.value)
						}
					>
						<option value="">Todos</option>
						<option value="factura">Factura</option>
						<option value="orden-compra">Orden de Compra</option>
						<option value="cotizacion">Cotización</option>
					</select>
				</div>
				<div className="col-md-2">
					<label>Estado</label>
					<select
						className="form-control"
						name="estado"
						id="estado"
						onChange={(e) =>
							handleFilterChange("estado", e.target.value)
						}
					>
						<option value="">Todos</option>
						<option value="pendiente">Pendiente</option>
						<option value="pagada">Pagada</option>
						<option value="cancelada">Cancelada</option>
						<option value="procesando">Procesando</option>
					</select>
				</div>
				<div className="col-md-2">
					<label>Vendedor</label>
					<Select
						id="vendedor"
						options={vendedores}
						name="vendedor"
						placeholder="Todos"
						onChange={(e) =>
							handleFilterChange("vendedor", e.value)
						}
						styles={{
							control: (styles) => ({
								...styles,
								height: "38px",
							}),
						}}
					/>
				</div>
				<div className="col-md-2">
					<label>Desde</label>
					<input
						className="form-control"
						type="date"
						name="desde"
						onChange={(e) =>
							handleFilterChange("desde", e.target.value)
						}
					/>
				</div>
				<div className="col-md-2">
					<label htmlFor="estado">Hasta</label>
					<input
						className="form-control"
						type="date"
						name="hasta"
						onChange={(e) =>
							handleFilterChange("hasta", e.target.value)
						}
						defaultValue={dayjs().format("YYYY-MM-DD")}
					/>
				</div>
			</FiltersContainer>
			<div className="row">
				<div className="col-md-12">
					<div>
						{loading && <Loader />}
						{!transacciones.data?.length ? (
							<div>
								{!loading && (
									<div>
										Todavía no hay transacciones creadas.
									</div>
								)}
							</div>
						) : (
							!loading && (
								<div className="table-data">
									<table className="table table-data2">
										<thead>
											<tr>
												<th>NCF/Número</th>
												<th>Fecha</th>
												<th>Vencimiento</th>
												<th>Fecha Pagada</th>
												<th>Total</th>
												<th>Por Cobrar</th>
												<th>Vendedor</th>
												<th>Tipo</th>
												<th className="text-center">
													Pago
												</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{transacciones.data.map(
												(transaccion) => (
													<tr
														className="tr-shadow"
														key={transaccion.id}
													>
														<td>
															{
																transaccion.numero_comprobante
															}
														</td>
														<td>
                                                            <span title={`Fecha creacion: ${transaccion.created_at}`}>
                                                                {dayjs(
                                                                    transaccion.fecha_emision
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                )}
                                                            </span>
														</td>
														<td>
															{dayjs(
																transaccion.fecha_vencimiento
															).format(
																"DD/MM/YYYY"
															)}
														</td>
														<td>
															{transaccion.estado ===
															"pagada"
																? dayjs(
																		transaccion.fecha_pago ||
																			transaccion.updated_at
																  ).format(
																		"DD/MM/YYYY, hh:mm a"
																  )
																: ""}
														</td>
														<td>
															{formatCurrency(
																transaccion.total,
																"$"
															)}
														</td>
														<td>
															{formatCurrency(
																transaccion.por_cobrar,
																"$"
															)}
														</td>
														<td>
															{
																transaccion.nombre_vendedor
															}
														</td>
														<td className="text-capitalize">
															{transaccion.entidad &&
																transaccion.entidad
																	.split("-")
																	.join(
																		" de "
																	)}
														</td>
														<td className="text-center">
															{renderEstadoBadge(
																transaccion.estado
															)}
														</td>
														<td></td>
														<td>
															<div
																className="table-data-feature"
																style={{
																	justifyContent:
																		"flex-start",
																}}
															>
																{/* {renderActionsBtns(
																	transaccion
																)} */}
																<Link
																	to={getViewLink(
																		transaccion
																	)}
																	target="_blank"
																	className="item"
																	title="Impresión normal"
																>
																	<i className="fas fa-eye"></i>
																</Link>
															</div>
														</td>
													</tr>
												)
											)}
										</tbody>
									</table>
									{transacciones.links && (
										<Pagination
											links={{
												next: transacciones.next_page_url,
												prev: transacciones.prev_page_url,
											}}
											meta={transacciones}
											getData={getTransactions}
										/>
									)}
								</div>
							)
						)}
					</div>
				</div>
			</div>
		</>
	);
};

const getViewLink = (transaccion) => {
	if (transaccion.entidad === "orden-compra")
		return getLink(`/imprimir/ordenes-compra/${transaccion.id}`);

	if (transaccion.entidad === "cotizacion")
		return getLink(`/imprimir/cotizaciones/${transaccion.id}`);

	return getLink(`/imprimir/facturas/${transaccion.id}`);
};

const Titulo = ({ contacto }) => {
	return (
		<span>
			<div style={{ fontSize: "1rem" }}>
				Historial de transacciones de{" "}
			</div>
			<span style={{ fontWeight: "600", fontSize: "1.1rem" }}>
				{contacto}
			</span>
		</span>
	);
};

export default History;
